import { useCurrentApp } from '@/stores/userDataStore';
import { useAppsByAppKey } from '@/api/queries/useAppsByAppKey';
import { IntegratedApp } from '@/constants/apps';
import { useMemo } from 'react';

export const useInstagramApps = () => {
  const { appKey } = useCurrentApp();
  const { data: apps = [], isLoading: isAppsLoading } = useAppsByAppKey(appKey);
  const instagramApps = useMemo(() => apps.filter((app) => app.active && app.app === IntegratedApp.INSTAGRAM), [apps]);
  return { instagramApps, isAppsLoading };
};
